export const CategoryCardFilter = (target: Element) => {
  const el = {
    form: target,
    manufacturerSelect: target.querySelector<HTMLSelectElement>('#search-manufacturer'),
    priceSelect: target.querySelector<HTMLSelectElement>('#search-price'),
    cards: target.querySelectorAll<HTMLDivElement>('.product-card'),
    cardsContainer: target.querySelector<HTMLDivElement>('.grid--products'),
  }

  const method = {
    init: () => {
      if (el.form) {
        el.form.addEventListener('submit', (e) => {
          e.preventDefault()
        })

        el.priceSelect &&
          el.manufacturerSelect.addEventListener('change', method.onSelectChange)
        el.priceSelect && el.priceSelect.addEventListener('change', method.onSelectChange)
      }
    },
    filter: (manufacturer: string, price: string) => {
      const messageContainer = el.cardsContainer.querySelector('.filter-message');
      let hasResults = false;

      if (el.cards) {
        el.cards.forEach((card) => {
          const cardPrice = parseInt(card.dataset.price, 10)
          const startPrice = parseInt(price, 10)
          const endPrice =
            price.indexOf('+') !== -1
              ? cardPrice >= startPrice
              : cardPrice >= startPrice && cardPrice <= startPrice + 10000

          const isManufacturer = manufacturer
            ? card.dataset.manufacturer === manufacturer
            : true
          const isPrice = price !== '' ? endPrice : true

          if (isManufacturer && isPrice) {
            card.classList.remove('h-hide')
            hasResults = true
          } else {
            card.classList.add('h-hide')
          }
        })
      }

      if (!hasResults) {
        if (!messageContainer) {
          const newMessageContainer = document.createElement('div');
          newMessageContainer.className = 'filter-message span-grid-12'
          newMessageContainer.innerHTML = 'Engar vörur fundust';
          el.cardsContainer && el.cardsContainer.appendChild(newMessageContainer);
        } else {
          messageContainer.classList.remove('h-hide')
        }
      }

      if (hasResults && messageContainer) {
        messageContainer.classList.add('h-hide')
      }
    },
    onSelectChange: () => {
      method.filter(el.manufacturerSelect.value, el.priceSelect.value)
    },
  }

  method.init()
}
